import _ from 'lodash';

import { FIRST_STEP } from 'utils';
import types from 'constants/actionTypes';
import { saveToStore } from 'actions/leadActions';
import { getPercentComplete } from 'actions/actionUtilities';
import { fireGtmEvent } from 'actions/appActions';

// @TODO Move the rest over to leadActions.ts

/**
 * once the lead is in place, calculate, etc
 */
export function rehydrate() {
  return (dispatch, getStore) => {
    const store = getStore();
    // @TODO: Update
    const currentStep = _.get(
      store,
      'router.location.pathname',
      `/${FIRST_STEP}`,
    )
      .slice(1)
      .split('/')[0];
    return dispatch(
      setPercentageComplete(getPercentComplete(currentStep, store.lead)),
    );
  };
}

export function markLocationOK(okay) {
  return saveToStore({
    locationOK: okay,
  });
}

export function setLanguage(language) {
  return saveToStore({
    language,
  });
}

export function setSelectedLocationMilage(milage) {
  return saveToStore({
    selectedLocationDistance: milage,
  });
}

export function setUpdating(updating) {
  return {
    type: types.SET_UPDATING,
    value: updating,
  };
}

/**
 * Private actions
 */

export function doubleCheckLocationOK({ updatedLead }) {
  return Boolean(
    updatedLead.locationID && updatedLead.franchiseID && updatedLead.locationOK,
  );
}

export function setPercentageComplete(pct) {
  return {
    type: types.SAVE_PERCENT_COMPLETE,
    payload: pct,
  };
}

/**
 * Check if any GTM events need to be fired
 */
export function processGtmEvents({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  stepToSave,
  updatedLead,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  existingLead,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  stepToNagivateTo = '',
}) {
  return (dispatch) => {
    if (
      updatedLead.inventoryStart === true ||
      updatedLead.currentStep === 'inventory'
    ) {
      dispatch(fireGtmEvent('inventoryStart'));
    }
    if (
      stepToSave === 'inventory' ||
      updatedLead.inventoryStageComplete === true
    ) {
      dispatch(fireGtmEvent('inventoryComplete'));
    }
  };
}
